import React,{useEffect, useState, useRef} from 'react';
import axios from 'axios';
import urls from '../../utils/url';
import { isJson, getReadableTime, getReadableDateOnly, getReadableTimeOnly} from '../../utils/converter';
import Dialog from '@mui/material/Dialog';
import Slide from '@mui/material/Slide';
import IntrapartumGraph from '../viewFiles/intrapartumData/IntrapartumGraph';
import * as htmlToImage from 'html-to-image';
import jsPDF from "jspdf"
import '../partograph/partograph.scss';
import Cookie from 'js-cookie';
import Loading from '../common/loading';
import Reload from '../common/Reload';
import {useNavigate, useLocation, useParams } from "react-router-dom";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const PartographLayout = (props) => {

  const { openPartograph, setOpenPartograph, handleClickOpen} = props;

  const partographRef = useRef(null);
  const navigate =  useNavigate();
  const cookie = Cookie.get('access_token')
  const [ loading, setLoading] = useState(false);
  const [ error, setError] = useState(false);
  const [ patientData, setPatientData] = useState();

  const {patientID} = useParams();
  const location = useLocation();

  useEffect(() => {
    // Check if data is not available in the location state
    if (!cookie) {
      navigate('/');
    }
  }, [ , navigate]);

  const handleClosePartograph = () => {
    navigate(-1);
  };


  const patientInfoItems = [
    { label: "Patient's Name", value: patientData?.basic_detail?.name || "--" },
    { label: "Gravida", value: patientData?.admission_note?.gravida || "--" },
    { label: "Hospital ID", value: patientData?.place_details?.[patientData?.basic_detail?.registration_place_id]?.name || "--" },
    { label: "Para", value: patientData?.admission_note?.para || "--" },
    { label: "Time of Admission", value: patientData?.basic_detail?.register_time ? getReadableTimeOnly(patientData.basic_detail.register_time) : "--" },
    { label: "Date of Admission", value: patientData?.basic_detail?.register_time ? getReadableDateOnly(patientData.basic_detail.register_time) : "--" },
    { label: "Membrane Rupture", value: patientData?.events.find(obj => obj.event === "membrane_ruptured") ? "--" : "Intact" },
    { label: "Membrane Rupture Time", value: patientData?.events.find(obj => obj.event === "membrane_ruptured") ? getReadableTime(patientData.events.find(obj => obj.event === "membrane_ruptured").event_time) : "--" },
  ];


  useEffect(() => {
    setLoading(true)
    axios.get(`${urls. BETA_URL}v1/nurse/patients/?patient_ids=${patientID}&forms=basic_detail,events,place_details,admission_note&`,
        {
          headers: {
          'Request-ID': 'allow|me', 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${cookie}`
        }
        }).then((res) => {
          if(res.data){
            const json_data = isJson(res.data)
           // console.log(json_data.response[0])
            setPatientData(json_data.response[0])
            setLoading(false) 
          }
        }).catch((err) => {
          console.log("Error in Fetching Data",err);
          setError(true)
          setPatientData()
          setLoading(false)
        }
      ) 
   }, [])
   
  const handleDownload = () => {
    const closeButton = document.querySelector('.close-button');
    const printButton = document.querySelector('.print-partograph');
    const partograph = document.getElementById('partograph-container');
    let originalWidth;

    // if (partograph) {
    //     // Store the original width of the partograph
    //     originalWidth = partograph.style.width;
    //     partograph.style.width = '1500px';
    // }
    closeButton.style.display = 'none';
    printButton.style.display = 'none';

    // Give time for the layout changes to take effect
    setTimeout(() => {
      htmlToImage.toPng(partograph)
          .then((dataUrl) => {
              const pdf = new jsPDF('p', 'mm', 'a4'); // 'p' for portrait mode
              pdf.addImage(dataUrl, 'PNG', 0, 0, 200, 290);
              window.open(pdf.output('bloburl'), '_self');
  
              partograph.style.width = originalWidth;
              closeButton.style.display = 'block';
              printButton.style.display = 'inline-flex';
          })
          .catch((error) => {
              console.error('Error generating PDF:', error);
              //partograph.style.width = originalWidth;
              closeButton.style.display = 'block';
              printButton.style.display = 'inline-flex';
          });
  }, 2000); // 2 seconds delay to allow layout updates
  
}


  const handleKeyDown = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault();
        alert('Please click on Print Partogaph button to print the Partograph');
      }
    };
    
  useEffect(() => {
    const handleKeyDownEvent = (e) => {
      handleKeyDown(e);
    };

    window.addEventListener('keydown', handleKeyDownEvent);

    return () => {
      window.removeEventListener('keydown', handleKeyDownEvent);
    };
  }, []);

  return ( 

    <>
      {
      loading ? <div className='loading-div'><Loading/></div> 
      : error ? <div className='reload-div'><Reload/></div>
      :
      <>
        {/* <Dialog fullScreen open={openPartograph} onClose={handleClosePartograph} TransitionComponent={Transition} > */}
        <div className='partograph-container'>
          <div style={{paddingTop:`2rem`,display:`flex`, flexDirection:`column`}} > 
            
            <img src="/back_arrow.svg" alt = "close" onClick={handleClosePartograph} style={{paddingLeft:`1rem`, width:`120px`, height:`30px`, cursor:`pointer`}} className='close-button'/>

            <div className='print-partograph' onClick={handleDownload}>
              <button className='print-partograph-button'>Print Partograph</button> 
            </div>

            <div ref={partographRef} id="partograph-container">
                <h3 style={{textAlign: `center`, textTransform:`capitalize`, fontWeight:`bold`}}> {patientData?.place_details[patientData?.basic_detail?.registration_place_id].name} -  SIMPLIFIED PARTOGRAPH </h3>

                <table className="partograph-table">
                  <tbody>
                    {patientInfoItems.reduce((rows, item, index) => {
                      if (index % 3 === 0) rows.push([]);
                      rows[rows.length - 1].push(item);
                      return rows;
                    }, []).map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {row.map((item, cellIndex) => (
                          <td key={cellIndex}>
                            <p className="text1">{item.label}</p>
                            <p className="text2 breakableText">{item.value}</p>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className='view-partograph' style={{width:`95%`, margin:`0px auto`, marginTop:`2rem`}}>
                  <IntrapartumGraph patientID={patientID}/>
                </div>
                
            </div>
          </div>
        </div>
        
     
      </>
      }
    </>
  )
}

export default PartographLayout